{
  "events-logger": {
    "event-logs": "Event Logs",
    "download": "Download Logs",
    "copy-to-clipboard": "Copy to clipboard",
    "expand": "Expand",
    "minimize": "Minimize",
    "no-events-logged-yet": "No events logged yet"
  },
  "header": {
    "session": "Session",
    "connected-as": "Connected as",
    "logout-from-call-center": "Logout",
    "going-online": "Going online...",
    "going-offline": "Going offline...",
    "went-online": "Went online",
    "went-offline": "Went offline",
    "go-online": "Go Online",
    "go-offline": "Go Offline",
    "handle-status": "Handle Status",
    "server-status": "Server Status",
    "network-status": "Network Status",
    "extension-number": "# Ext.",
    "connecting-to-sip": "Connecting to the SIP server...",
    "offline": "Offline",
    "online": "Online"
  },
  "session": {
    "loading": "Loading...",
    "authenticating": "Authenticating...",
    "loading-user-info": "Loading user information...",
    "connecting-to-sip": "Connecting to the SIP server...",
    "offline": "You are <1>offline</1>. Calls won't be forwarded to your extension.",
    "online": "You are <1>online</1>. Incoming calls will appear here."
  },
  "new-call": {
    "call-extension": "Call Extension",
    "type-extension": "Type extension to call or press buttons",
    "calling-extension": "Calling {{extension}}",
    "calling": "Calling...",
    "hang-up": "Hang Up",
    "type-extension-button": "Type extension",
    "call-button": "Call {{extension}}"
  },
  "intercom": {
    "access-controls": {
      "title": "Access Controls",
      "description": "Manage gate access and parking controls",
      "shared-dialog": {
        "cost-field": "Cost (optional)",
        "cost-field-placeholder": "Enter cost",
        "reason-field": "Reason",
        "reason-field-placeholder": "Enter reason for this action",
        "cancel": "Cancel",
        "submit": "Submit",
        "gate": "Gate: {{gateName}}"
      },
      "open-locked-gate": {
        "title": "Hold gate open",
        "description": "Opens the gate and keeps it open until someone presses Close.",
        "confirm-before-submit": "CAUTION: This action will leave {{gateName}} open until someone presses Close.",
        "submitting": "Holding gate open...",
        "success": "Gate is being held open",
        "error": "Failed to hold the gate open",
        "button": "Hold gate open"
      },
      "open-gate": {
        "title": "Open Gate",
        "description": "Open the gate for vehicle access",
        "submitting": "Opening gate...",
        "success": "Gate opened successfully",
        "error": "Failed to open gate",
        "button": "Open Gate"
      },
      "close-gate": {
        "title": "Close the gate",
        "description": "Releases any hold, then closes the gate.",
        "submitting": "Closing gate...",
        "success": "Gate closed successfully",
        "error": "Failed to close gate",
        "button": "Close the gate"
      },
      "send-lost-ticket": {
        "title": "Send Lost Ticket",
        "description": "Send a lost ticket notification",
        "submitting": "Sending lost ticket...",
        "success": "Lost ticket sent successfully",
        "error": "Failed to send lost ticket",
        "button": "Send Lost Ticket"
      },
      "activate-loop": {
        "title": "Activate Loop",
        "description": "Activate the loop detector",
        "submitting": "Activating loop...",
        "success": "Loop activated successfully",
        "error": "Failed to activate loop",
        "button": "Activate Loop"
      },
      "gate-status": {
        "acts-on-label": "These controls act on:",
        "acts-on": "These controls act on: {{gateName}}",
        "loading": "Loading gate status...",
        "unavailable": "Status unavailable",
        "barrier-up": "Barrier up",
        "barrier-down": "Barrier down",
        "barrier-up-for": "Up for at least {{minutes}} min",
        "shared-device": "Shared with {{gateName}}: this reading can be about either barrier.",
        "vehicle-present": "Vehicle at the terminal",
        "vehicle-absent": "No vehicle at the terminal",
        "terminal-connected": "Terminal connected",
        "terminal-disconnected": "Terminal disconnected",
        "terminal-disconnected-warning": "Commands may not reach the gate.",
        "held": "Held open",
        "held-since": "Held open since {{time}}",
        "held-reason": "Reason: {{reason}}",
        "printer": {
          "inError": "Printer error",
          "paperJam": "Printer: paper jam",
          "paperMissing": "Printer: out of paper",
          "coverOpened": "Printer: cover open",
          "paperNearEnd": "Printer: paper almost out"
        }
      }
    },
    "camera-feed": {
      "title": "Camera Feed",
      "description": "Live camera view of the parking area",
      "no-camera-available": "No camera available",
      "sip-camera-has-no-video-tracks": "Video stream not available when call is on hold.",
      "sip-camera-disconnection-warning": "The video stream will be lost when the call is put on hold. When resuming the call, the video stream will be restored.",
      "button": "Camera Feed"
    },
    "procedures": {
      "intercom": {
        "title": "Intercom Procedures",
        "description": "Intercom procedures",
        "no-procedures-available": "No intercom procedures available",
        "button": "Intercom Procedures"
      },
      "parking": {
        "title": "Parking Procedures",
        "description": "Parking procedures",
        "no-procedures-available": "No parking procedures available",
        "button": "Parking Procedures"
      }
    },
    "contacts": {
      "title": "Emergency Contacts",
      "description": "Emergency contacts",
      "no-contacts-available": "No emergency contacts available",
      "button": "Emergency Contacts"
    }
  },
  "announcement": {
    "title": "Release Notes",
    "got-it": "Got it"
  },
  "call-controls": {
    "answer": "Answer",
    "decline": "Decline",
    "resume": "Resume",
    "hold": "Hold",
    "hang-up": "Hang Up",
    "keypad": "Keypad",
    "mute-input": "Mute Microphone",
    "unmute-input": "Unmute Microphone",
    "mute-output": "Mute Speaker",
    "unmute-output": "Unmute Speaker"
  },
  "devices": {
    "call-input": "Call Input",
    "call-output": "Call Output",
    "notification-output": "Notification Output"
  },
  "sidebar": {
    "history": "Call History",
    "unknown": "Unknown",
    "from": "from",
    "to": "to",
    "no-entries-found": "No entries found",
    "no-calls-found": "No calls found",
    "load-more": "Load More",
    "loading-more": "Loading..."
  },
  "history": {
    "call-back": "Call Back",
    "call-back-to-reactivate-video-stream": "Calling back will reactivate the video stream."
  }
}